import { PkEmptyMessage, PkIdentifier } from '@uefadigital/panenka-react';
import useViewportSpy from 'beautiful-react-hooks/useViewportSpy';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useAvailablePdfLinks } from '../../../hooks/useAvailablePdfLink';

import PDF from 'assets/pdf.svg';
import useIsDesktop from 'hooks/useIsDesktop';
import { useMatchData } from 'hooks/useMatchData';

interface Link {
  link: string;
  name: string;
}

export const PrintMatchPressKitsTab = () => {
  const { matchData } = useMatchData();

  const { t } = useTranslation();
  const isDesktop = useIsDesktop();
  const ref = useRef(null);
  const isVisible = useViewportSpy(ref);
  const availableLinks = useAvailablePdfLinks(matchData, !!isVisible);

  const Title = isDesktop
    ? 'pk-font-size--xl3 pk-font-style--normal pk-font--comp-bold'
    : 'pk-font-size--xl pk-line-height--md pk-font-style--normal pk-font--comp-bold';

  return (
    <div className="pk-container pk-pt--m pk-pt-md--xl2 pk-mb--xl2" ref={ref}>
      <div className="pk-col pk-col--span-12 pk-mb--m pk-mb-md--xl2">
        <h1 className={`${Title} pk-text--text-01`}>{t('print_match_information_kits')}</h1>
      </div>
      <>
        {availableLinks?.links?.length ? (
          availableLinks?.links.map((pdfLink: Link, index) => {
            return (
              <div className="pk-col pk-col--span-ss-4 pk-col--span-md-3" key={index}>
                <PkEmptyMessage className="pk-d--flex pk-align-items--start pk-shadow--none">
                  <a target="_blank" href={pdfLink.link} rel="noreferrer">
                    <PkIdentifier alignment="left">
                      <span slot="prefix" className="pk-mr--l">
                        <img alt="Pdf" src={PDF} />
                      </span>
                      <span
                        slot="secondary"
                        className="pk-line-height--md pk-text--ui-06 pk-font-weight--normal pk-font-size--s pk-text--wrap"
                      >
                        {t(pdfLink.name)}
                      </span>
                    </PkIdentifier>
                  </a>
                </PkEmptyMessage>
              </div>
            );
          })
        ) : (
          <div className="pk-col pk-col--span-12 pk-my--l">
            <PkEmptyMessage>{t('pdfs_for_the_match_are_not_available_yet')}</PkEmptyMessage>
          </div>
        )}
      </>
    </div>
  );
};
